export default __webpack_public_path__ + "static/media/mobile number.fef8a54a.png";